export const REGEX_DATE_EU = /^([0-9]{2})-([0-9]{2})-([0-9]{4})$/;
export const REGEX_DATETIME_EU =
  /^([0-9]{2})-([0-9]{2})-([0-9]{4}) ([0-9]{2}):([0-9]{2}):([0-9]{2})$/;
export const REGEX_HAS_SPECIAL_CHARACTERS = /^[a-zA-Z0-9\s\u00C0-\u017F]*$/;
